import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "w-full border-b" }
const _hoisted_2 = { class: "flex items-start justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-16px mb-3 font-medium" }, " Siap di Kargo ", -1)
const _hoisted_4 = { class: "flex flex-col gap-y-3" }
const _hoisted_5 = { class: "text-14px font-semibold text-black-lp-300" }
const _hoisted_6 = { class: "capitalize" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_8 = { class: "capitalize" }
const _hoisted_9 = { class: "text-12px text-gray-lp-800" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Jumlah Bagging : ")
const _hoisted_11 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_HorizontalScrollContainer = _resolveComponent("HorizontalScrollContainer")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("img", {
        src: _imports_0,
        class: "w-5 cursor-pointer mr-4",
        alt: "close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      })
    ]),
    _createVNode(_component_HorizontalScrollContainer, {
      hideScroll: false,
      class: "pb-6",
      onOnScrollRight: _ctx.fetchReadyToCargoList,
      key: _ctx.keyReadyToCargo
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.readyToCargoList.data, (readyToCargo, index) => {
          return (_openBlock(), _createBlock("div", {
            onClick: ($event: any) => (_ctx.confirmationProcessReadyToCargo(readyToCargo)),
            key: index,
            style: {"background-image":"linear-gradient(180deg, #FFFFFF 1.36%, rgba(254, 232, 235, 0.1) 322.15%)","min-width":"280px"},
            class: "bg-pink-lp-200 cursor-pointer border border-red-lp-300 rounded-lg px-6 py-4 overflow-hidden flex justify-between gap-x-4 mr-6 mb-4"
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(readyToCargo.originName), 1),
                _hoisted_7,
                _createVNode("span", _hoisted_8, _toDisplayString(readyToCargo.destinationName), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("span", _hoisted_11, _toDisplayString(readyToCargo.totalBagging), 1)
              ])
            ]),
            _createVNode(_component_Icons, {
              name: "chevron-right",
              class: "text-black-lp-300"
            })
          ], 8, ["onClick"]))
        }), 128)),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.loadingCard, (i) => {
          return (_openBlock(), _createBlock(_component_Skeleton, {
            key: i,
            height: "85px",
            style: {"padding":"16px 140px"},
            class: "rounded-lg overflow-hidden flex justify-between gap-x-4 mr-6 mb-4"
          }))
        }), 128))
      ]),
      _: 1
    }, 8, ["onOnScrollRight"])
  ]))
}